const BIO = [
  "Doreen Zaki is passionate about seeing African SMEs succeed, grow, and excel. She believes Africa holds vast untapped potential, and that unlocking it starts with equipping founders with the tools, structure, and access they need to be truly investable.",
  "She is an affiliate of Clinq Africa, a Kenyan fintech/SaaS platform helping SMEs become capital-ready by generating the documents funders require most — pitch decks, financial models, management accounts, and business valuations — and connecting them to matched capital partners including VCs, banks, grants, and impact investors.",
  "With a decade of experience helping businesses raise capital across the African market, Doreen serves as a Transaction Advisor at Stadia Capital Advisory, where her work spans corporate deals including M&A and share sales. She has been closely involved in developing Clinq Africa's Capital Readiness Score (CRS) — a proprietary methodology built by reviewing over 1,000 funder mandates, giving SMEs a clear roadmap of exactly what they need to do to secure funding and how to position their documentation to meet funder expectations.",
];

const STATS = [
  ["10+ yrs", "raising capital across Africa"],
  ["USD 20m+", "raised for businesses from Africa-focused funders"],
  ["M&A", "Transaction Advisor, Stadia Capital"],
];

export const DiscoveryBio = () => (
  <section className="bg-[#F5F7F7]" data-testid="discovery-bio">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 py-16 sm:py-20 lg:grid-cols-[minmax(0,380px)_1fr] lg:gap-16">
      <div className="relative mx-auto w-full max-w-[380px] lg:mx-0">
        <div className="pointer-events-none absolute -left-4 -top-4 h-full w-full rounded-[28px] border-2 border-[#E3B84C]/60" />
        <img src="/doreen-zaki.jpg" alt="Doreen Zaki, capital raising expert and Clinq Africa affiliate"
          className="relative aspect-[4/5] w-full rounded-[28px] object-cover object-top shadow-[0_30px_60px_-30px_rgba(11,42,40,0.5)]"
          data-testid="discovery-bio-photo" />
        <div className="relative -mt-8 ml-6 mr-2 rounded-2xl bg-[#0B2A28] px-5 py-4 text-white shadow-lg">
          <p className="text-base font-extrabold md:text-lg">Doreen Zaki</p>
          <p className="text-xs text-[#7BD3CE]">Capital raising expert · Transaction Advisor · Clinq Africa affiliate</p>
        </div>
      </div>
      <div>
        <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-[#0A8B85]">Who you'll be working with</p>
        <h2 className="mt-3 text-2xl font-extrabold text-[#0B2A28] sm:text-3xl" data-testid="discovery-bio-heading">Meet Doreen</h2>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-neutral-700 sm:text-base" data-testid="discovery-bio-text">
          {BIO.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
        </div>
        <div className="mt-8 grid gap-3 sm:grid-cols-3">
          {STATS.map(([n, l]) => (
            <div key={n} className="rounded-2xl border border-neutral-200 bg-white p-4">
              <p className="text-xl font-extrabold text-[#0A8B85]">{n}</p>
              <p className="mt-1 text-xs text-neutral-500">{l}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
